import axios from "axios";

const singleton = Symbol();
const singletonEnforcer = Symbol();

class IonInterface {
    constructor() {
        this.session = axios.create({
            baseURL: "https://api.cesium.com",

            headers: {
                'Content-Type': 'application/json',
            }
        });
    }

    static get instance() {
        // Try to get an efficient singleton
        if (!this[singleton]) {
            this[singleton] = new IonInterface(singletonEnforcer);
        }

        return this[singleton];
    }

    getAssets = async (token) => this.session.get("v1/assets",
        {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }
    )
}
export default IonInterface